import component from './commitment.component';
import item from './item/item.component';

export default angular.module('mpdx.tools.fix.commitmentInfo', [component, item]).name;
